import { types } from 'mobx-state-tree';

export enum JOB_APPLICATION_STATES {
  STATE_LOADING = 'loading',
  STATE_LOADED = 'loaded',
  STATE_ERROR = 'error',
  STATE_SUMMARY = 'summary',
}

export const STATE_LOADING = JOB_APPLICATION_STATES.STATE_LOADING;
export const STATE_LOADED = JOB_APPLICATION_STATES.STATE_LOADED;
export const STATE_ERROR = JOB_APPLICATION_STATES.STATE_ERROR;
export const STATE_SUMMARY = JOB_APPLICATION_STATES.STATE_SUMMARY;

export const stateType = types.optional(
  types.enumeration('State', [STATE_LOADING, STATE_LOADED, STATE_ERROR]),
  STATE_LOADING,
);

export const ACTION_DONE = 'done';
export const ACTION_ERROR = 'error';
export const ACTION_VALIDATION_ERROR = 'validation_error';

export const stateTypeWithSummary = types.optional(
  types.enumeration('StateWithSummary', [
    STATE_SUMMARY,
    STATE_LOADING,
    STATE_LOADED,
    STATE_ERROR,
  ]),
  STATE_SUMMARY,
);
